class ListOffers {

    constructor() {
        var container = jQuery(".flex-list-offers");

        container.find('input').bind("keyup", function(){
            var strToSearch = $(this).val();
            container.find(".block-offer").hide();
            container.find(".block-offer:contains('"+strToSearch+"')").show();
            jQuery(document).trigger('scroll');
        });
    }

}

jQuery(document).ready(function ($) { new ListOffers() });
